module.exports = __webpack_public_path__ + "VIPV3.png?3908bacc0387f82e0b9c7c8697a2a605";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV3.png
// module id = 125
// module chunks = 0